const ratingComponents = document.querySelectorAll('.star-rating');
ratingComponents.forEach(ratingComponent => {
    const controls = ratingComponent.querySelectorAll('.star-rating-control__input');
    const items = ratingComponent.querySelectorAll('.star-rating__item');

    controls.forEach(control => {
        control.addEventListener('change', evt => {
            changeRatingValue(controls, control.getAttribute('value') - 1);
        });
    });

    items.forEach(item => {
        let control = item.querySelectorAll('.star-rating-control__input')[0];

        item.addEventListener('mouseenter', evt => {
            control && changeRatingValue(controls, control.getAttribute('value') - 1);
        });
    });

    ratingComponent.addEventListener('mouseleave', evt => {
        let activeItem = false;

        controls.forEach(control => {
            if (control.checked) {
                changeRatingValue(controls, control.getAttribute('value') - 1);
                activeItem = true;
            }
        });

        if (activeItem === false && controls && controls.length) {
            changeRatingValue(controls, -1);
        }
    });
});

const changeRatingValue = function (controls, current) {
    for (let i = 0; i < controls.length; i++) {
        const control = controls[i];

        if (i <= current) {
            control.classList.add('star-rating-control--active');
        } else {
            control.classList.remove('star-rating-control--active');
        }

    }
}
